// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const PHOTO_UPLOAD_ABORTED_UPLOAD = "Preru\u0161en\u00e9";
export const PHOTO_UPLOAD_FILE_IS_TOO_BIG = "S\u00fabor je pr\u00edli\u0161 ve\u013ek\u00fd";
export const PHOTO_UPLOAD_WRONG_IMAGE_FORMAT = "Nespr\u00e1vny typ s\u00faboru. M\u00e1 ma\u0165 pr\u00edponu JPG, PNG alebo GIF";
